import { Routes } from "@angular/router";
import { ImprintComponent } from "./policy/imprint/imprint.component";
import { HomeComponent } from "./home/home.component";
import { PageNotFoundComponent } from "./layout/page-not-found/page-not-found.component";
import { PrivacyComponent } from "./policy/privacy/privacy.component";
import { AgentCreateComponent } from "./agent/agent-create/agent-create.component";
import { AgentDetailsComponent } from "./agent/agent-details/agent-details.component";
import { AgentListComponent } from "./agent/agent-list/agent-list.component";
// import { AppointmentComponent } from "./appointment/appointment.component";
import { ApprovalComponent } from "./approval/approval.component";
import { LoginComponent } from "./auth/login/login.component";
import { RegisterComponent } from "./auth/register/register.component";
import { FaqComponent } from "./faq/faq.component";
import { MailComponent } from "./mail/mail.component";
import { MediumFormComponent } from "./media/medium-form/medium-form.component";
// import { MediumDetailsComponent } from "./media/medium-details/medium-details.component";
import { MediumListComponent } from "./media/medium-list/medium-list.component";
import { PresentationComponent } from "./presentation/presentation.component";
import { PendingComponent } from "./registration/pending/pending.component";
import { ThankYouComponent } from "./registration/thank-you/thank-you.component";
import { TodoListComponent } from "./todo-list/todo-list.component";
import { TutorialsComponent } from "./tutorials/tutorials.component";
import { IconsComponent } from "./ui-design-library/icons/icons.component";
import { UserDetailsComponent } from "./user/user-details/user-details.component";
import { UserListComponent } from "./user/user-list/user-list.component";
import { UserSearchComponent } from "./user/user-search/user-search.component";
import { UserComponent } from "./user/user.component";
import { authGuardFn } from "./auth/auth.guard";
import { roleGuardFn } from "./auth/role.guard";
import { TemplateListComponent } from "./templates/template-list/template-list.component";
import { TemplateCreateComponent } from "./templates/template-create/template-create.component";
import { TemplateDetailsComponent } from "./templates/template-details/template-details.component";
import { ChecksComponent } from "./checks/checks.component";
import { MediumDetailsComponent } from "./media/medium-details/medium-details.component";

export const routes: Routes = [
  // {
  //   path: "terminvereinbarung",
  //   component: SchedulingComponent,
  //   data: {
  //     title: "Terminvereinbarung 📅",
  //     breadcrumb: "Terminvereinbarung",
  //     description:
  //       "Vereinbaren Sie jederzeit einen (Video-)Termin oder buchen Sie einen Rückruf! Von Altersvorsorge bis Zahnersatz #bgrgDE",
  //     keywords:
  //       "Barmenia Geschäftsstelle Raphael Gruber Karlsruhe Termin Terminvereinbarung Online-Termin Video-Termin Kalender Online-Kalender Termin vereinbaren Rückruf vereinbaren",
  //   },
  // },

  {
    path: "registrieren", component: RegisterComponent,
    data: { title: "Registrieren", breadcrumb: "" }
  },
  {
    path: "registrierung",
    children: [
      {
        path: "",
        component: RegisterComponent,
        data: { title: "Registrieren", breadcrumb: "" }
      },
      {
        path: "anstehend",
        component: PendingComponent,
        data: { title: "Haben Sie vielen Dank! So geht's weiter ...", breadcrumb: "" },
      },
      {
        path: "danke",
        component: ThankYouComponent,
        data: { title: "Das hat geklappt - vielen Dank!", breadcrumb: "" }
      },
    ],
  },
  {
    path: "anmelden",
    component: LoginComponent,
    data: { title: "Anmelden", breadcrumb: "" }
  },
  // {
  //   path: "kontakt",
  //   children: [
  //     { path: '', component: KontaktComponent, title: 'Kontakt' },
  //     {
  //       path: "terminvereinbarung",
  //       component: AppointmentComponent,
  //       canActivate: [authGuardFn],
  //       data: { title: "Terminvereinbarung", breadcrumb: "" }
  //     },
  //   ],
  // },
  {
    path: "mail",
    component: MailComponent,
    canActivate: [authGuardFn],
    data: { title: "Infomail ✉️ versenden", breadcrumb: "" }
  },
  {
    path: "admin",
    canActivate: [roleGuardFn],
    data: { expectedRole: "admin", title: "", breadcrumb: "" },
    children: [
      {
        path: "todo/list",
        component: TodoListComponent,
        data: { title: "Todo-Liste", breadcrumb: "" }
      },
      {
        path: "ui",
        component: IconsComponent,
        data: { title: "Icons", breadcrumb: "" }
      },
      {
        path: "checks",
        component: ChecksComponent,
        data: { title: "Checks", breadcrumb: "" }
      },
    ],
  },
  {
    path: "user",
    canActivate: [roleGuardFn],
    data: { expectedRole: "admin", title: "", breadcrumb: "" },
    children: [
      {
        path: "",
        component: UserComponent,
        data: { title: "", breadcrumb: "" }
      },
      {
        path: "list",
        component: UserListComponent,
        data: { title: "Benutzerliste", breadcrumb: "" }
      },
      {
        path: "search",
        component: UserSearchComponent,
        data: { title: "Benutzersuche", breadcrumb: "" }
      },
      {
        path: ":id",
        component: UserDetailsComponent,
        data: { title: "Benutzerdetails", breadcrumb: "" }
      },
    ],
  },
  {
    path: "approval/user",
    component: ApprovalComponent,
    data: { title: "Benutzerfreigaben", breadcrumb: "" }
  },
  {
    path: "agent",
    canActivate: [roleGuardFn],
    data: { expectedRole: "admin", title: "", breadcrumb: "" },
    children: [
      {
        path: "list",
        component: AgentListComponent,
        data: { title: "Vermittlerliste", breadcrumb: "" }
      },
      {
        path: "new",
        component: AgentCreateComponent,
        data: { title: "Vermittler anlegen", breadcrumb: "" }
      },
      {
        path: ":id",
        component: AgentDetailsComponent,
        data: { title: "Vermittlerdetails", breadcrumb: "" }
      },
    ],
  },
  {
    path: "template",
    canActivate: [roleGuardFn],
    data: { expectedRole: "admin", title: "", breadcrumb: "" },
    children: [
      {
        path: "list",
        component: TemplateListComponent,
        data: { title: "Vorlagenübersicht", breadcrumb: "" }
      },
      {
        path: "new",
        component: TemplateCreateComponent,
        data: { title: "Vorlage erstellen", breadcrumb: "" }
      },
      {
        path: ":id",
        component: TemplateDetailsComponent,
        data: { title: "Vorlage", breadcrumb: "" }
      },
    ],
  },
  {
    path: "medium",
    canActivate: [roleGuardFn],
    data: { expectedRole: "admin", title: "", breadcrumb: "" },
    children: [
      {
        path: "list",
        component: MediumListComponent,
        data: { title: "Mediumsliste", breadcrumb: "" }
      },
      {
        path: "new",
        component: MediumFormComponent,
        data: { title: "Medium anlegen", breadcrumb: "" }
      },
      {
        path: ":id",
        component: MediumFormComponent,
        data: { title: "Mediumdetails", breadcrumb: "" }
      },
      {
        path: "details/:id",
        component: MediumDetailsComponent,
        data: { title: "Mediumdetails", breadcrumb: "" }
      },
    ],
  },
  {
    path: "presentation",
    component: PresentationComponent,
    canActivate: [roleGuardFn],
    data: { expectedRole: "admin", title: "", breadcrumb: "" }
  },
  {
    path: "support/faqs",
    component: FaqComponent,
    data: { title: "Support | Antworten", breadcrumb: "" }
  },
  {
    path: "support/tutorials",
    component: TutorialsComponent,
    data: { title: "Support | Tutorials", breadcrumb: "" }
  },




  {
    path: "impressum",
    component: ImprintComponent,
    data: { title: "Impressum", breadcrumb: "Impressum" },
  },
  {
    path: "datenschutz",
    component: PrivacyComponent,
    data: { title: "Datenschutz", breadcrumb: "Impressum" },
  },
  {
    path: "",
    component: HomeComponent,
    pathMatch: "full",
    data: { title: "Startseite" },
  },
  {
    path: "**",
    component: PageNotFoundComponent,
    data: { title: "Fehler 404 - Seite nicht gefunden" },
  },
];